import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field as ReduxFormField } from 'redux-form';
import { Field as FinalFormField } from 'react-final-form';
import Col from 'react-bootstrap/lib/Col';
import elementType from 'prop-types-extra/lib/elementType';
import { pick, keys } from 'lodash/fp';
import { GroupControl } from '../../GroupField';
import Control from '../Control';

const getColProps = pick(keys(Col.propTypes));

export default class Field extends PureComponent {
  static propTypes = {
    isReactFinalForm: PropTypes.bool,
    type: PropTypes.string.isRequired,
    Box: elementType,
    Container: elementType,
  };

  static defaultPropTypes = {
    isReactFinalForm: false,
  };

  renderBox = (boxProps) => {
    const { className, inputNode, iconNode, labelNode, value } = boxProps;
    const { Box, type } = this.props;
    const colProps = getColProps(this.props);

    return (
      <Col {...colProps} data-qa-selector={type}>
        {Box ? (
          <Box {...boxProps} />
        ) : (
          <label className={className} data-qa-value={value}>
            {inputNode}
            {iconNode}
            {labelNode}
          </label>
        )}
      </Col>
    );
  };

  renderComponent = (props) => {
    const { type } = this.props;

    return <GroupControl {...props} type={type} />;
  };

  render() {
    const { type, isReactFinalForm, ...props } = this.props;

    const Field = isReactFinalForm ? FinalFormField : ReduxFormField;

    return (
      <Field
        {...props}
        component={this.renderComponent}
        FormControl={Control}
        Box={this.renderBox}
      />
    );
  }
}
